import { BaseModel } from "@/models/base.model"
import { type ISaleItem } from "@/interfaces/api/sale-item.interface"
import type { Units } from "@/enums/units.enum"
import { unitToName } from "@/helper/enums/unit-helper"

export class SaleItem extends BaseModel implements ISaleItem {
  public static className = "SaleItem" // Used for socket communication.

  public static verboseName = "Verkoopartikel"

  id: string

  name: string

  unit: Units

  unitPrice: string | undefined

  surchargeModifier: string | undefined

  constructor(saleItem: ISaleItem) {
    super(saleItem)

    this.id = saleItem.id
    this.name = saleItem.name
    this.unit = saleItem.unit
    this.unitPrice = saleItem.unitPrice
    this.surchargeModifier = saleItem.surchargeModifier
  }

  public getDisplayText() {
    return `${this.name} ${this.getUnitName()} € ${this.unitPrice}`
  }

  public getUnitName() {
    return unitToName(this.unit)
  }
}
